import RemoteIcon from './RemoteIcon';

export default RemoteIcon;
